import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserdataService } from '../services/userdata.service';
import { Router } from '@angular/router';
import { AdDataService } from '../services/addata.service';
import { AdbookingService } from '../services/adbooking.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  user: { userdata: any; };
  userprofile: any;
  username: any;
  constructor(private userdataservice: UserdataService, private bookingService: AdbookingService,
              private adservice: AdDataService, private router: Router) { }

  ngOnInit() {

    this.userdataservice.getUserDataSubject().subscribe(data => {
      this.user = data;
    });
    // this.username = this.userprofile.set('name').value;
  }

  ngOnDestroy(): void {
    this.userdataservice.getUserDataSubject().unsubscribe();
  }

  logout() {
    this.userdataservice.setUserData(null);
    this.adservice.setAdData(null);
    sessionStorage.clear();
    this.router.navigate(['/home']);
  }

  home() {
    this.adservice.setAdData(null);
    sessionStorage.removeItem('Array');
    this.router.navigate(['/home']);
  }
}
